import {TreeViewDefaultItemModelProperties} from '@mui/x-tree-view';

import {
  STRUCTURE_ID_FAVORITE_ASSETS,
  STRUCTURE_ID_MEDIENEINGANG,
} from '../../constants';

import type {StructureResponseItemDto} from '../dto';

const FAVORITE_STRUCTURE_RESULT_ITEM: StructureResponseItemDto = {
  id: STRUCTURE_ID_FAVORITE_ASSETS,
  accessLevel: -1,
  name: 'Lieblingsbilder',
  parentId: null,
  favorite: true,
  topLevel: true,
};

export const FAVORITE_STRUCTURE_TREE_ITEM: StructureTreeViewItem = {
  id: FAVORITE_STRUCTURE_RESULT_ITEM.id,
  children: [],
  label: FAVORITE_STRUCTURE_RESULT_ITEM.name,
  details: FAVORITE_STRUCTURE_RESULT_ITEM,
};

export const MEDIENEINGANG_STRUCTURE_RESULT_ITEM: StructureResponseItemDto = {
  id: STRUCTURE_ID_MEDIENEINGANG,
  accessLevel: -1,
  name: 'Persönlicher Medieneingang',
  parentId: null,
  favorite: false,
  topLevel: true,
};

export interface StructureTreeViewItem extends TreeViewDefaultItemModelProperties {
  children: StructureTreeViewItem[];
  parent?: StructureTreeViewItem;
  details: StructureResponseItemDto;
}

export interface CustomTreeItemProps {
  showFullPathTooltip?: boolean;
}

export interface StructureMainViewProps {
  structure: Map<string, StructureResponseItemDto>;
}

export interface StructureContextMenuProps {
  contextAnchorEl;
  setContextAnchorEl: (element: HTMLElement | null) => void;
  contextItem: StructureResponseItemDto;
}
export interface StructureChangeDialogProps {
  contextItem: StructureResponseItemDto | null;
  open: boolean;
  action: StructureContextEntries | undefined;
  onClose: () => void;
}

export interface ContextAnchorPosition {
  top: number;
  left: number;
}

export enum StructureContextEntries {
  CREATE = 1,
  EDIT = 2,
  DELETE = 3,
  FAVORITE = 4,
  UNFAVORITE = 5,
  CLEAR_INBOX = 99,
  CLEAR_FAVORITES = 98,
}
